import { Alert, Link, styled } from "@mui/material";
import { Trans } from "react-i18next";

import type { PredefinedLEZOption } from "src/types";

interface Props {
  options: PredefinedLEZOption[];
  selectedOption: string;
  loadedOption: string;
  readOnly: boolean;
  isLoading: boolean;
  onLoad: () => void;
}

export function FleetConfigLoadAlert(props: Props) {
  const { options, selectedOption, loadedOption, readOnly, isLoading, onLoad } =
    props;

  function getFleetLabel(nameKey: string) {
    return (
      options.find((option) => option.nameKey === nameKey)?.nameTranslation ??
      nameKey
    );
  }

  return (
    <Styles severity="info">
      <Trans
        i18nKey="label.loadPredefinedFleetToApply"
        values={{
          selectedFleet: getFleetLabel(selectedOption),
          loadedFleet: getFleetLabel(loadedOption),
        }}
        components={{
          loadLink: (
            <Link
              component="button"
              variant="inherit"
              underline="always"
              disabled={readOnly || isLoading}
              onClick={onLoad}
            />
          ),
        }}
      />
    </Styles>
  );
}

const Styles = styled(Alert)`
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  .MuiAlert-message .MuiLink-root {
    display: inline;
    vertical-align: baseline;
    line-height: inherit;
    font: inherit;
  }
`;
